import { render, staticRenderFns } from "./DashboardTables.vue?vue&type=template&id=2dcfd42c&scoped=true"
import script from "./DashboardTables.vue?vue&type=script&lang=js"
export * from "./DashboardTables.vue?vue&type=script&lang=js"
import style0 from "./DashboardTables.vue?vue&type=style&index=0&id=2dcfd42c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcfd42c",
  null
  
)

export default component.exports